export default "__VITE_ASSET__DOhvfshf__"